window.onload = function () {
    
    //Lineas para el modal
    var confirm = document.getElementById("confirm");
    // Get the <span> element that closes the modal
    var span2 = document.getElementsByClassName("close2")[0];
    // When the user clicks on <span> (x), close the modal
    span2.onclick = function () {
        confirm.style.display = "none";
    }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
        if (event.target === confirm) {
            confirm.style.display = "none";
        }
    }

    //Lineas para el modal de error
    var error = document.getElementById("error");
    // Get the <span> element that closes the modal
    var span3 = document.getElementsByClassName("close3")[0];
    // When the user clicks on <span> (x), close the modal
    span3.onclick = function () {
        error.style.display = "none";
    }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
        if (event.target === error) {
            error.style.display = "none";
        }
    }

    //Lineas para el form e reingreso
    const signUpButton = document.getElementById('signUp');
    const signInButton = document.getElementById('signIn');
    const contenedor = document.getElementById('contenedor');

    signUpButton.addEventListener('click', () => {
        contenedor.classList.add("right-panel-active");
    });

    signInButton.addEventListener('click', () => {
        contenedor.classList.remove("right-panel-active");
    });

    //Lineas para el modal de reingreso
    var reingreso = document.getElementById("reingreso");
    // Get the <span> element that closes the modal
    // var span4 = document.getElementsByClassName("close4")[0];
    // // When the user clicks on <span> (x), close the modal
    // span4.onclick = function () {
    //     reingreso.style.display = "none";
    // }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
        if (event.target === reingreso) {
            reingreso.style.display = "none";
        }
    }
}
